import { inject, Injectable, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SidepanelService } from 'mbs-ui-kit/sidepanel/sidepanel.service';
import { ComputerBackupFacade } from 'mbs-ui-shared@facades/computer.backup.facade';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { BehaviorSubject, delay, filter, map, Observable, switchMap, take, tap } from 'rxjs';
import { RestoreWizardSettings } from 'wizards/models/base/base-plan-models';
import { PlanModalWrapper } from './plan.wrapper';

@Injectable({
  providedIn: 'root'
})
export class RestoreWizardWrapper {
  private backupFacade = inject(ComputerBackupFacade);
  private computersFacade = inject(ComputersFacade);
  private planWrapper = inject(PlanModalWrapper);
  private sidepanelService = inject(SidepanelService);
  private injector = inject(Injector);

  public openRestoreWizard$ = new BehaviorSubject<RestoreWizardSettings>(undefined);

  get restoreWizardPipe(): Observable<RestoreWizardSettings> {
    return this.openRestoreWizard$.pipe(
      filter(Boolean),
      switchMap((wizardSettings) =>
        this.planWrapper.startRestoreBySettings(wizardSettings).pipe(
          filter((result) => result === 'Save'),
          map(() => wizardSettings)
        )
      ),
      tap(() => this.sidepanelService.removeAll()),
      switchMap((wizardSettings) =>
        toObservable(this.computersFacade.getByHid(wizardSettings?.targetComputerData?.hid), { injector: this.injector }).pipe(
          filter(Boolean),
          take(1),
          tap((computer) => this.backupFacade.loadPlans({ computer, force: true })),
          map(() => wizardSettings)
        )
      ),
      delay(200)
    );
  }
}
